import {Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TrainingItemGroupManagementConstants } from './constants/training-item-group-management-constants';
import { ConfirmationService, MessageService } from 'primeng/api';
import { NameCode } from '../../models/name-code';
import { TrainingItemGroupsLookupRequest } from './models/training-item-groups-lookup-request';
import { TrainingItemGroupManagementService } from './services/training-item-group-management.service';
import { UpdateTrainingItemGroupsRequest } from './models/update-training-item-groups-request';
import { SharedConstants } from '../../constants/shared-constants';
import { DocumentService } from '../../../document/services/document.service';
import { finalize } from 'rxjs/operators';
import { CourseService } from '../../../../app/course/services/course.service';


@Component({
  selector: 'app-training-item-group-management',
  templateUrl: './training-item-group-management.component.html',
  styleUrls: ['./training-item-group-management.component.scss'],
})
export class TrainingItemGroupManagementComponent implements OnInit {
  @Input() isTrainingItemGroupManagementSliderOpen: boolean = false;
  @Input() defaultTrainingItemGroups: NameCode[] = [];
  @Input() trainingItemGroupsLookupRequest!: TrainingItemGroupsLookupRequest;
  @Output() isTrainingItemGroupManagementActive = new EventEmitter<boolean>();
  trainingItemGroupManagementHeaderText: string =
    TrainingItemGroupManagementConstants.trainingItemGroupManagementHeaderText;
  trainingItemGroups: any[] = [];
  valueField: string = 'code';
  labelField: string = 'name';
  selectedTrainingItemGroups:any[] = [];
  initialSelectedTrainingItemGroups:any[] = [];
  isSaveEnabled : boolean = false;
  updateTrainingItemGroupsRequest! : UpdateTrainingItemGroupsRequest;
  trainingItemGroupsNotUpdated: any[] = [];
  isTrainingItemGroupDetailsLoading: boolean = false;
  

  constructor(private confirmationService: ConfirmationService, 
    private trainingItemGroupManagementService: TrainingItemGroupManagementService, private documentService: DocumentService,
    private courseService:CourseService,
    private messageService: MessageService) { }
  ngOnInit(): void {
    this.isTrainingItemGroupDetailsLoading = true;
    this.getExistingTrainingItemGroups()
  }

  setUpdateTrainingItemsRequest(itemsToAdd : string[], itemsToRemove : string[]) {
    this.updateTrainingItemGroupsRequest = {
      trainingItemNumber : this.trainingItemGroupsLookupRequest?.trainingItemId,
      trainingItemType : this.trainingItemGroupsLookupRequest?.trainingItemType,
      trainingItemsAddedTo : itemsToAdd,
      trainingItemsRemovedFrom : itemsToRemove
    };
  }

  toggleSaveButtonAvailability() {
    if(this.selectedTrainingItemGroups.length > 0 || 
      (this.selectedTrainingItemGroups.length == 0 && this.initialSelectedTrainingItemGroups.length > 0)) 
      {
        this.isSaveEnabled = true;
      } 
      else 
      {
        this.isSaveEnabled = false;
      }
  }

getExistingTrainingItemGroups() {
  const { trainingItemType, trainingItemId } = this.trainingItemGroupsLookupRequest;
  let request$;
  if (trainingItemType === 1) {
    request$ = this.documentService.getTrainingItemGroupForDocument(trainingItemId);
  } else if (trainingItemType === 2) {
    request$ = this.courseService.getTrainingItemGroupsForCourse(trainingItemId);
  } else {
    return;
  }
  request$.subscribe(response => {
    this.defaultTrainingItemGroups = response;
    this.getTrainingItemGroupsLookUp();
  });
}
  getTrainingItemGroupsLookUp(){
    this.trainingItemGroupManagementService.getTrainingItemGroupsLookup(this.trainingItemGroupsLookupRequest).subscribe((response)=>{
      this.trainingItemGroups = response;
      this.selectedTrainingItemGroups = this.defaultTrainingItemGroups.map(item => item.code);
      this.selectedTrainingItemGroups = this.selectedTrainingItemGroups.filter(item => 
      this.trainingItemGroups.some(group => group.code === item)
    );
    this.initialSelectedTrainingItemGroups = [...this.selectedTrainingItemGroups];
    this.toggleSaveButtonAvailability();
    this.setUpdateTrainingItemsRequest([],[]);
    this.isTrainingItemGroupDetailsLoading = false;
    })
  }

  setTrainingItemGroups = () => {
    this.toggleSaveButtonAvailability();
  }

  saveTrainingItemGroupManagement = () => {
    this.isTrainingItemGroupDetailsLoading = true;
    const addedItems = this.selectedTrainingItemGroups.filter(item => 
      !this.initialSelectedTrainingItemGroups.some(initialItem => initialItem === item)
    );
    const removedItems = this.initialSelectedTrainingItemGroups.filter(initialItem => 
      !this.selectedTrainingItemGroups.some(item => item === initialItem)
    );
    this.setUpdateTrainingItemsRequest(addedItems,removedItems);
    this.trainingItemGroupManagementService.updateTrainingItemGroups(this.updateTrainingItemGroupsRequest).pipe(
      finalize(() => {
        this.isTrainingItemGroupDetailsLoading = false;
      })
    ).subscribe(
      (response) => {
        this.trainingItemGroupsNotUpdated = response;  
        if (this.trainingItemGroupsNotUpdated.length > 0) {
          let removedItems = this.trainingItemGroupsNotUpdated.join(", ");
          this.messageService.add({
            severity: SharedConstants.Severity_Error,
            summary: SharedConstants.TrainingItemGroupManagement_ValidationMessage,
            detail: removedItems,
            sticky: true
          });
        }
        else {
          this.messageService.add({
            severity: SharedConstants.Severity_Success,
            summary: SharedConstants.TrainingItemGroupManagement_SuccessMessage,
            sticky: false
          });
        }
      },
      (error) => {
        console.error('Error while updating training item groups:', error);
      }
    );
    setTimeout(() => {
    this.closeSlider();
    },2000);
  }


  openConfirmationModal = () => {
    this.confirmationService.confirm({
      header: TrainingItemGroupManagementConstants.trainingItemGroupManagementConfirmationHeaderText,
      message: TrainingItemGroupManagementConstants.trainingItemGroupManagementConfirmationMessageText,
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.closeSlider();
      },
      acceptIcon : "pi pi-check",
      rejectIcon : "pi pi-times"
    });
  }

  closeSlider = (): void => {
    this.resetSlider()
    this.isTrainingItemGroupManagementSliderOpen = false;
    this.isTrainingItemGroupManagementActive.emit(this.isTrainingItemGroupManagementSliderOpen);
  }
  
  resetSlider() {
    this.selectedTrainingItemGroups = [];
    this.initialSelectedTrainingItemGroups = [];
    this.setUpdateTrainingItemsRequest([],[]);
  }

}
